module.exports = __webpack_public_path__ + "img/logo-its.6ecd99a2.jpg";